import { createSlice } from '@reduxjs/toolkit';

export const largeTableSlice = createSlice({
  name: 'largeTable',
  initialState: {
    displayLargeTableMsg: false,
  },
  reducers: {
    updateDisplayLargeTableMsg: (state, action) => {
      state.displayLargeTableMsg = action.payload;
    },
  },
});

export const { updateDisplayLargeTableMsg } = largeTableSlice.actions;

export default largeTableSlice.reducer;
